import { render, staticRenderFns } from "./ZinusTestMaster.vue?vue&type=template&id=2a83a48c"
import script from "./ZinusTestMaster.ts?vue&type=script&lang=ts&external"
export * from "./ZinusTestMaster.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports